import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState } from "react";
// ==================== CONTEXT ====================
// Create a context for managing the selected subscription link ID.
// Initialize with default values: `selectedSubLinkId` as `undefined`
// and `setSelectedSubLinkId` as an empty function to avoid undefined access.
export const MyMealsMenuContext = createContext({
    selectedSubLinkId: undefined,
    setSelectedSubLinkId: () => { },
});
// ==================== PROVIDER COMPONENT ====================
// Define a provider component that will hold the `selectedSubLinkId` state and
// provide a `setSelectedSubLinkId` function to update it. This component wraps
// its children and makes the state available throughout the component tree.
export const MyMealsMenuProvider = ({ children }) => {
    // Create a state variable `selectedSubLinkId` with the initial value of `undefined`.
    const [selectedSubLinkId, setSelectedSubLinkId] = useState(undefined);
    // Return a context provider that supplies the state (`selectedSubLinkId`) and the
    // function to update it (`setSelectedSubLinkId`) to all child components.
    return (_jsx(MyMealsMenuContext.Provider, Object.assign({ value: { selectedSubLinkId, setSelectedSubLinkId } }, { children: children })));
};
// ==================== HOOK FOR CONTEXT ====================
// Create a custom hook that allows components to access the `MyMealsMenuContext`.
// This hook returns the context value, which contains both the `selectedSubLinkId`
// and the `setSelectedSubLinkId` function, enabling components to consume the context easily.
export const useMyMealsMenuContext = () => React.useContext(MyMealsMenuContext);
